import { AlbumResults, TrackResults } from '.'
import { ResultsProps } from './Results.types'

const Results = ({
	playlistTracks,
	user,
	locale,
}: ResultsProps): JSX.Element => {
	return (
		<>
			<AlbumResults locale={locale} />
			<TrackResults playlistTracks={playlistTracks} user={user} />
		</>
	)
}

export default Results
